import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, firstValueFrom } from 'rxjs';
import { FirebaseService } from 'src/app/firebase/firebase.service';
import { AKOU_BRAIN_URL, AKOU_IFRAME_SELECTOR, AKOU_PUBLIC_KEY, AKOU_ROUTE_FRAGMENT, AKOU_WIDGET_URL } from './akou-conf';

@Injectable({
  providedIn: 'root'
})
export class AkouService {

  private scriptLoaded = false;

  constructor(private router: Router, private firebaseService: FirebaseService) {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((navEnd: NavigationEnd) => {
      this.handleNavigation(navEnd.urlAfterRedirects);
    });
    this.handleNavigation(this.router.url);
  }

  private async handleNavigation(url: string): Promise<void> {
    if (!url.includes(AKOU_ROUTE_FRAGMENT)) {
      this.setWidgetVisibility(false);
      return;
    }
    if (this.scriptLoaded) {
      this.setWidgetVisibility(true);
      return;
    }
    const user = await firstValueFrom(this.firebaseService.getCurrentUserProperties());
    if (user && !this.scriptLoaded && this.router.url.includes(AKOU_ROUTE_FRAGMENT)) {
      this.injectScript();
    }
  }

  private injectScript(): void {
    this.scriptLoaded = true;
    const script = document.createElement('script');
    script.src = AKOU_WIDGET_URL;
    script.defer = true;
    script.setAttribute('data-key', AKOU_PUBLIC_KEY);
    script.setAttribute('data-brain-url', AKOU_BRAIN_URL);
    document.body.appendChild(script);
  }

  private setWidgetVisibility(visible: boolean): void {
    const iframe = document.querySelector<HTMLIFrameElement>(AKOU_IFRAME_SELECTOR);
    if (iframe) {
      iframe.style.display = visible ? '' : 'none';
    }
  }
}
